module.exports = __webpack_public_path__ + "static/media/salmah.5d974129.png";